<template>
  <div class="surgaltiinbaiguullaga">
    <div class="container">
      <div class="surgaltiinbaiguullaga_title">
        <div class="row">
          <div class="col-md-12">
            <div class="left">
              <h3>Сургалтын байгууллага</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="surgaltiinbaiguullaga_tab">
        <div class="tab_input">
          <div class="row">
            <div class="col-md-6">
              <h4>Нийт: {{ total | number }}</h4>
            </div>
            <div class="col-md-3">
              <div class="search-section">
                <Input @on-search="calldata"  search placeholder="Хайх..." v-model="searchWord"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="search-section">
                <Select v-model="orderTypePre"  @on-change="changeOrder">
                  <Option v-for="item in orders" :value="item.value" :key="item.value" >{{ item.label }}</Option>
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-3">
              <div class="main_left">
                <h3>Сургалтын байгууллага</h3>
                <a href="javascript:void(0)" @click="cleanFilter" class="clean_button"><i class="fa fa-refresh"></i></a>
                <div class="list">
                  <Select v-model="select_umchiin_helber" placeholder="Өмчийн хэлбэр">
                    <Option v-for="t in umchiimHelbers" :value="t.id" :key="t.id">{{ t.title }}</Option>
                  </Select>
                </div>
                <div class="list">
                  <Select v-model="select_hev_shinj" placeholder="Салбар">
                    <Option v-for="t in hewshinjs" :value="t.id" :key="t.id">{{ t.title }}</Option>
                  </Select>
                </div>
<!--                <div class="list">-->
<!--                  <Select v-model="orderTypePre"  @on-change="changeOrder">-->
<!--                    <Option v-for="item in orders" :value="item.value" :key="item.value" >{{ item.label }}</Option>-->
<!--                  </Select>-->
<!--                </div>-->
              </div>
<!--              <div class="main_left">-->
<!--                <h3>Эрэмбэлэх</h3>-->
<!--                <div class="list">-->
<!--                  <Select v-model="orderTypePre"  @on-change="changeOrder">-->
<!--                    <Option v-for="item in orders" :value="item.value" :key="item.value" >{{ item.label }}</Option>-->
<!--                  </Select>-->
<!--                </div>-->
<!--              </div>-->
              <div class="main_left">
                <h3>Аймаг</h3>
                <div class="list">
                  <CheckboxGroup v-model="filtered_aimag">
                    <div class="checkbox" :key="index" v-for="(aimag, index) in aimags">
                      <Checkbox :label="aimag.id">{{ aimag.aimagname }}<span></span></Checkbox>
                    </div>
                  </CheckboxGroup>
                </div>
              </div>
              <div class="haih">
                <Button class="button" @click="calldata"><i class="fa fa-search"></i>Хайх</Button>
              </div>
            </div>
            <div class="col-md-9">
              <div class="surgaltiinbaiguullaga_table">
<!--                <div class="row">-->
<!--                  <div class="col-md-12">-->
                    <table width="100%">
                      <thead>
                      <tr>
                        <th>№</th>
                        <th>СУРГАЛТЫН БАЙГУУЛЛАГА</th>
                        <th>ӨМЧИЙН ХЭЛБЭР</th>
                        <th>СУРГАЛТ ЭРХЭЛЖ БУЙ МЭРГЭЖИЛ</th>
                        <th>АЙМАГ НИЙСЛЭЛ</th>
                        <th>УТАС</th>
                        <th>ХАЯГ</th>
                        <th>ЦАХИМ ХУУДАС</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" v-for="(baiguullaga, index) in surgaltiinbaiguullaga">
                        <td>
                          <span v-if="current_page == 1">{{ index + 1 }}</span>
                          <span v-else>{{ ((current_page - 1) * 9) + (index + 1) }}</span>
                        </td>
                        <td>
                          <!--                                                <div class="baiguulgiin_turul">-->
                          <!--                                                    <img src="../assets/flooop.svg" alt="">-->
                          <!--                                                    <p>{{baiguullaga.school_title}}</p>-->
                          <!--                                                </div>-->
                          {{ baiguullaga.school_title }}
                        </td>
                        <td>{{ baiguullaga.titleomch }}</td>
                        <td>
                          <Button @click="surgaltHutulburModal(baiguullaga.id)" class="button">
                            <i class="fa fa-external-link"></i>Мэргэжил харах
                          </Button>
                        </td>
                        <td>{{ baiguullaga.aimagname }}</td>
                        <td>{{ baiguullaga.utas_1 }}</td>
                        <td class="tooltip_hayg">
                          <Tooltip max-width="300" :content="baiguullaga.hayg">
                            <div class="hayg">
                              <i class="fa fa-map-marker"></i>
                            </div>
                          </Tooltip>
                        </td>
                        <td ><a :href="baiguullaga.web_link" target="_blank" > Зочлох </a></td>

                      </tr>

                      </tbody>
                    </table>
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
        </div>
        <div class="pagenation">
          <Page @on-change="changePageSurgaltiinBaiguullaga"
                :current-page="current_page"
                :page-size="100"
                :total="total"
          />
        </div>
<!--        <Tabs value="name1">-->
<!--          <TabPane label="СУРГАЛТЫН БАЙГУУЛЛАГА" name="name1">-->
<!--            <div class="tab_input">-->
<!--              <div class="row">-->
<!--                <div class="col-md-4"></div>-->
<!--                <div class="col-6 col-md-3"><h4>Нийт: {{ total | number }}</h4></div>-->
<!--                <div class="col-6 col-md-5">-->
<!--                  <div class="search-section">-->
<!--                    <Input @on-search="calldata"  search enter-button  placeholder="Хайх..." v-model="searchWord"/>-->

<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="surgaltiinbaiguullaga_table">-->
<!--              <div class="row">-->
<!--                <div class="col-md-12">-->
<!--                  <table width="100%">-->
<!--                    <thead>-->
<!--                    <tr>-->
<!--                      <th>№</th>-->
<!--                      <th>СУРГАЛТЫН БАЙГУУЛЛАГА</th>-->
<!--                      <th>ӨМЧИЙН ХЭЛБЭР</th>-->
<!--                      <th>СУРГАЛТЫН ХӨТӨЛБӨР</th>-->
<!--                      <th>АЙМАГ НИЙСЛЭЛ</th>-->
<!--                      <th>УТАС</th>-->
<!--                      <th>ХАЯГ</th>-->
<!--                      <th>ЦАХИМ ХУУДАС</th>-->
<!--                    </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                    <tr :key="index" v-for="(baiguullaga, index) in surgaltiinbaiguullaga">-->
<!--                      <td>-->
<!--                        <span v-if="current_page == 1">{{ index + 1 }}</span>-->
<!--                        <span v-else>{{ ((current_page - 1) * 9) + (index + 1) }}</span>-->
<!--                      </td>-->
<!--                      <td>-->
<!--                        &lt;!&ndash;                                                <div class="baiguulgiin_turul">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                    <img src="../assets/flooop.svg" alt="">&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                    <p>{{baiguullaga.school_title}}</p>&ndash;&gt;-->
<!--                        &lt;!&ndash;                                                </div>&ndash;&gt;-->
<!--                        {{ baiguullaga.school_title }}-->
<!--                      </td>-->
<!--                      <td>{{ baiguullaga.titleomch }}</td>-->
<!--                      <td>-->
<!--                        <Button @click="surgaltHutulburModal(baiguullaga.id)" class="button"><i-->
<!--                            class="fa fa-external-link"></i>Хөтөлбөр харах-->
<!--                        </Button>-->
<!--                      </td>-->
<!--                      <td>{{ baiguullaga.aimagner }}</td>-->
<!--                      <td>{{ baiguullaga.utas_1 }}</td>-->
<!--                      <td class="tooltip_hayg">-->
<!--                        <Tooltip max-width="300" :content="baiguullaga.hayg">-->
<!--                          <div class="hayg">-->
<!--                            <i class="fa fa-map-marker"></i>-->
<!--                          </div>-->
<!--                        </Tooltip>-->
<!--                      </td>-->
<!--                      <td><a :href="baiguullaga.web_link" target="_blank">{{ baiguullaga.web_link }}</a></td>-->

<!--                    </tr>-->

<!--                    </tbody>-->
<!--                  </table>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="pagenation">-->
<!--              <Page @on-change="changePageSurgaltiinBaiguullaga"-->
<!--                    :current-page="current_page"-->
<!--                    :page-size="9"-->
<!--                    :total="total"-->
<!--              />-->
<!--            </div>-->
<!--          </TabPane>-->
<!--          <TabPane label="СУРГАЛТЫН ТӨВ" name="name2">-->
<!--            <surgaltiinTuv></surgaltiinTuv>-->
<!--          </TabPane>-->
<!--        </Tabs>-->
      </div>
    </div>
    <Modal
        v-model="surgaltHutulbur"
        :styles="{top: '200px'}"
        title="БЭЛТГЭЖ БУЙ МЭРГЭЖИЛ"
    >
      <div id="modal-main">
        <table width="100%">
          <thead>
          <tr>
            <th>№</th>
            <th>Сургалтын түвшин</th>
            <th>Мэргэшлийн түвшин</th>
            <th>Суралцах хугацаа</th>
            <th>Мэргэжил</th>
<!--            <th>Төлбөртэй эсэх</th>-->
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(hutulbur, index) in s_hutulburs">
            <td>{{index+1}}</td>
            <td>{{ hutulbur.tp_level }}</td>
            <td>{{ hutulbur.tp_rate }}</td>
            <td>{{ hutulbur.tp_duratioin }}</td>
            <td>{{ hutulbur.tp_name }}</td>
<!--            <td v-if="hutulbur.tolbortei_eseh == 0" class="true_green">Төлбөргүй</td>-->
<!--            <td v-else class="true_red">Төлбөртэй</td>-->
          </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer">

      </div>
    </Modal>

  </div>
</template>

<script>
import {getSurgaltBaiguullaga, getHutulbur} from "../api/index"
// import surgaltiinTuv from './section/surgaltiinTuv';


export default {

  // components: {
  //   surgaltiinTuv: surgaltiinTuv,
  // },
  data() {
    return {
      surgaltHutulbur: false,
      surgaltiinbaiguullaga: [],
      current_page: 1,
      last_page: 1,
      total: 0,
      searchWord: null,
      select_hev_shinj: null,
      select_umchiin_helber: null,
      filtered_aimag: [],
      s_hutulburs: [],
      aimags: [],
      umchiimHelbers: [],
      hewshinjs: [],
      orders: [
        {
          value: 'name-asc',
          label: 'Сургалтын байгуулгын нэр А - Я'
        },
        {
          value: 'name-desc',
          label: 'Сургалтын байгуулгын нэр Я - А'
        },
      ],
      order: "ASC",
      orderTypePre: "name-asc",
    }
  },
  mounted() {
    this.calldata();
    this.aimags = window.init.aimag;
    this.umchiimHelbers = window.init.umchiimHelbers;
    this.hewshinjs = window.init.hewshinj;
  },
  methods: {
    changeOrder(value) {
      if(value == "name-desc"){
        this.order = 'DESC';
      } else if(value == "name-asc"){
        this.order = 'ASC';
      }
      this.calldata();
    },
    calldata() {
      this.$isLoading(true);
      getSurgaltBaiguullaga(this.current_page, {
        searchWord: this.searchWord,
        umchiimHelbers: this.select_umchiin_helber,
        hewshinj: this.select_hev_shinj,
        aimag: this.filtered_aimag,
        //OrderType: this.orderType,
        Order:this.order
      }).then(response => {
        this.surgaltiinbaiguullaga = response.data.data;
        // this.surgaltiinbaiguullaga = [...response.data.data.map(row => {
        //   return         {
        //     name: row.school_title,
        //     umch: row.titleomch,
        //     age: 26,
        //     address: 'Ottawa No. 2 Lake Park',
        //     date: '2016-10-04'
        //   }
        // })];
        this.current_page = response.data.current_page;
        this.last_page = response.data.last_page;
        this.total = response.data.total;
        //console.log(this.surgaltiinbaiguullaga);
        //console.log(this.total);
        this.$isLoading(false);
      }).catch(error => {
        this.$Loading.error();
        console.log('ErrorL ', error);
      });
    },
    cleanFilter() {
      this.searchWord =  null;
      this.select_umchiin_helber =  null;
      this.select_hev_shinj =  null;
      this.filtered_aimag =  [];
      this.orderTypePre =  'name-asc';
      this.calldata();
    },
    changePageSurgaltiinBaiguullaga(page) {
      this.current_page = page;
      this.calldata();
    },
    surgaltHutulburModal(id) {
      this.school_id = id;
      this.surgaltHutulbur = true;
      getHutulbur(this.school_id).then(response => {
        this.s_hutulburs = response.data;
        // console.log(this.s_hutulburs);
        this.$isLoading(false);
      }).catch(error => {
        this.$Loading.error();
        console.log('ErrorL ', error);
      });
    },

  },
  computed: {

  },
}
</script>
